export default __webpack_public_path__ + "img/5aaed34c6f63d5547488c19f06fd348c.svg";